import { useEffect, useState, useCallback, useContext } from 'react'
import './FindYourMatch.css'
import { Button, TitlePage } from '../../atoms'
import { Corporate, OptionTypes } from '../../types/types'
import { Link } from 'react-router-dom'
import MultiSelectComponent from 'components/atoms/Select/MultiSelectComponent'
import { MultiValue } from 'react-select'
import { AppGeneralContext } from 'shared/GeneralContext/GeneralContext'
import { CompaniesListReq } from 'components/types/Api'
import useMediaQuery from 'hook/useMediaQuery'
import { MediaTablet } from 'api/const/MediaQuery'
import { initialPager } from 'components/types/InitialData'
import { useAuth } from 'shared/auth'
import SelectComponent from 'components/atoms/Select/SelectComponent'
import { postCompaniesList } from 'api/Api'
import { useDebounce } from 'shared/hook/useDebounce'
import { isStringEmpty } from 'shared/utils/utils'

interface iFindYourMatch {
    setSelectedId?: (selectedId: string) => void
}

export const FindYourMatch = ({ setSelectedId }: iFindYourMatch) => {
    const {
        numberMatchRequest,
        loadingFilterOptions,
        getFilterOptionsList,
        setLoadingFilterOptions,
        user,
        filter,
        setFilter,
        startUp,
        reqCorporate,
        setReqCorporate,
        getCorporatesList,
        setPagerCorporatesList,
        loginType,
        setErrorModal
    } = useContext(AppGeneralContext)

    const matchAvaible = numberMatchRequest ? numberMatchRequest : 0
    const [departments, setDepartments] = useState<MultiValue<OptionTypes>>()
    const [interests, setInterests] = useState<MultiValue<OptionTypes>>()
    const [levels, setLevels] = useState<MultiValue<OptionTypes>>()
    const [tags, setTags] = useState<MultiValue<OptionTypes>>()
    const [searchText, setSearchText] = useState<string>("")
    const debouncedValue = useDebounce(searchText, 500)
    const Disabled = (departments && departments.length !== 0) ||
        (interests && interests.length !== 0) ||
        (levels && levels.length !== 0) ||
        (tags && tags.length !== 0) || (!!searchText && !isStringEmpty(searchText))? false : true
    const tablet = useMediaQuery(MediaTablet)
    const { auth } = useAuth()



    useEffect(() => {
        if (!user?.Startup?.canMatch) {
            return
        }
        let logged = auth?.jwtToken ? true : false
        getFilterOptionsList(logged)
    }, [])

    useEffect(() => {
        let logged = auth?.jwtToken ? true : false
        getFilterOptionsList(logged)


    }, [startUp.currentPlan?.monthMatches,
        matchAvaible,
        numberMatchRequest, auth])


    const filterOption = (par: MultiValue<OptionTypes> | undefined) => {
        let optionsValue: string[] = par?.map(x => x.value) ?? []
        return optionsValue
    }

    useEffect(() => {
        getCorporatesList()

    }, [reqCorporate])

    useEffect(() => {
        search()
    }, [interests, departments, tags, levels, debouncedValue])


    const search = useCallback(
        () => {
            
            const trimmedValue = debouncedValue?.trim()
            console.log({ trimmedValue })
            setSelectedId?.("")
            let filterDepartments = filterOption(departments)
            let filterInterests = filterOption(interests)
            let filterLevels = filterOption(levels)
            let filterTags = filterOption(tags)
            let req: CompaniesListReq = {
                ...reqCorporate, pageNum: 0,
                departments: filterDepartments,
                sectors: filterInterests,
                levels: filterLevels,
                tags: filterTags,
                searchText:trimmedValue
            }
            setReqCorporate(req);
            setPagerCorporatesList(initialPager)
        },
        [reqCorporate, departments, interests, levels, tags, debouncedValue]
    )

    const cancel = () => {
    
        setSelectedId?.("")
        setDepartments(undefined);
        setInterests(undefined);
        setLevels(undefined);
        setTags(undefined);
        setSearchText("")
        let req: CompaniesListReq = {
            ...reqCorporate,
            departments: [],
            sectors: [],
            tags: [],
            levels: [],
            searchText:''
        }
        setReqCorporate(req);
    }



    useEffect(() => {
        if (loadingFilterOptions
            // || startUp.currentPlan?.monthMatches === 0 
            || Disabled) {
            cancel()
        }

    }, [loadingFilterOptions, startUp.currentPlan?.monthMatches, Disabled])


    //FIX 2/12/2024
    const handleSingleChangeChoice = (opt: MultiValue<OptionTypes>, setOption: (opt: MultiValue<OptionTypes>) => void) => {
        setOption(opt.slice(-1))
    }

    return (
        <div className="row d-flex flex-row w-100 m-0 ">
            <div className="col-12 mt-5 w-100">
                <TitlePage as="h3" className='font-weight-bold' title='Find Your Next Perfect Match' />
                <h4 className='mt-3 fw-700'>
                    You have <span className='tx-primary'>{matchAvaible}</span> Ask for a Match available. <Link to="/start-up/profile/upgrade-plan" className='tx-primary tx-underline cursor-pointer'>Upgrade your plan!</Link>
                </h4>
            </div>
            <div className="col-12 mt-3">
                <div className="row align-items-center">
                    <div className="col-xs-12 col-sm-12 col-md-4 mt-3 mt-md-0">
                        <input
                            placeholder='Search Company'
                            className="form-input"
                            type="text"
                            onChange={e => setSearchText(e.target.value)}
                            value={searchText}
                            name="Search Company"
                            maxLength={100}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-4 mt-3 mt-md-0">
                        <MultiSelectComponent
                            isLoading={loadingFilterOptions}
                            isSearchable
                            // disabled={startUp.currentPlan?.monthMatches === 0}
                            heightControlSection="47px"
                            setOptionSelected={(opt) => handleSingleChangeChoice(opt, setInterests)}
                            placeholder='Interests'
                            className={"w-100"}
                            options={filter.sectors ? filter.sectors : []}
                            fieldName={'Interests'}
                            value={interests ? interests : null}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-4 mt-3 mt-md-0">
                        <MultiSelectComponent
                            isLoading={loadingFilterOptions}
                            isSearchable
                            // disabled={startUp.currentPlan?.monthMatches === 0}
                            heightControlSection="47px"
                            setOptionSelected={(opt) => handleSingleChangeChoice(opt, setDepartments)}
                            placeholder='Departments'
                            className={"w-100"}
                            options={filter.departments ? filter.departments : []}
                            fieldName={'departments'}
                            value={departments ? departments : null}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-4 mt-3 mt-md-0">
                        <MultiSelectComponent
                            isLoading={loadingFilterOptions}
                            isSearchable
                            // disabled={startUp.currentPlan?.monthMatches === 0}
                            heightControlSection="47px"
                            setOptionSelected={(opt) => handleSingleChangeChoice(opt, setLevels)}
                            placeholder='Levels'
                            className={"w-100"}
                            options={filter.levels ? filter.levels : []}
                            fieldName={'levels'}
                            value={levels ? levels : null}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-4 mt-3 mt-md-0">
                        <MultiSelectComponent
                            isLoading={loadingFilterOptions}
                            isSearchable
                            // disabled={startUp.currentPlan?.monthMatches === 0}
                            heightControlSection="47px"
                            setOptionSelected={(opt) => handleSingleChangeChoice(opt, setTags)}
                            placeholder='Tags'
                            className={"w-100"}
                            options={filter.tags ? filter.tags : []}
                            fieldName={'tags'}
                            value={tags ? tags : null}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-4 d-flex justify-content-between mt-3">
                        <Button disabled={loadingFilterOptions
                            // || startUp.currentPlan?.monthMatches === 0 
                            || Disabled} onClick={() => { cancel() }} className='ps-0 pe-0 w-100' color='var(--black)' background='var(--white)' borderColor='var(--black)' fontWeight={'800'} uppercase primary text='cancel' type='button' />
                    </div>
                </div>
            </div>
        </div>
    )
}
